import { defineMessages } from 'react-intl';
import { useMixpanel } from '../../../../contexts';
import { useDynamicCallback } from '../../../../hooks';
import { MixpanelEvent } from '../../../../tokens';
import { Button, ButtonVariants } from '../../../Button';
import { FormControlSizes } from '../../../Form';
import { IconName } from '../../../Icons';
import { IndicatorBadgeVariants, IndicatorBadgeWrapper } from '../../../IndicatorBadge';
import { FormattedMessage } from '../../../Intl';
import { Text } from '../../../Text';

const messages = defineMessages({
  filters: {
    defaultMessage: 'Filters',
    id: 'Filters.FilterBuilder.filters',
  },
});

export interface FilterBuilderToggleButtonProps {
  activeFilterCount: number;
  isOpen: boolean;
  onClick: () => void;
  size?: FormControlSizes;
}

export const FilterBuilderToggleButton = ({
  activeFilterCount,
  isOpen,
  onClick,
  size = FormControlSizes.Small,
}: FilterBuilderToggleButtonProps) => {
  const mixpanel = useMixpanel();

  const handleOnClick = useDynamicCallback(() => {
    onClick();
    if (!isOpen) {
      mixpanel.track(MixpanelEvent.ClickOpenFilterBuilderButton);
    }
  });

  return (
    <Button
      variant={isOpen ? ButtonVariants.Primary : ButtonVariants.Default}
      data-is-expanded={isOpen}
      size={size}
      startIcon={IconName.Filter}
      onClick={handleOnClick}
      data-testid="filter-builder-toggle-button"
    >
      <IndicatorBadgeWrapper
        show={activeFilterCount > 0}
        variant={isOpen ? IndicatorBadgeVariants.Default : IndicatorBadgeVariants.Notification}
        content={activeFilterCount}
      >
        <Text weight="500">
          <FormattedMessage {...messages.filters} />
        </Text>
      </IndicatorBadgeWrapper>
    </Button>
  );
};
